import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContextType, useAuth } from "../contexts/AuthContext";
import { Box, Typography, Button } from "@mui/material";

function Home() {
  const userAuthContext: AuthContextType = useAuth();
  useEffect(() => {
    document.title = "Ganesh";
  }, [location]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
        textAlign: "center",
      }}
    >
      {userAuthContext.isAuthenticated ? (
        <div>
          <Typography variant="h4" gutterBottom>
            Welcome to Ganesh,{" "}
            {userAuthContext.authAttributes?.first_name || "dataplor guest"}!
          </Typography>
        </div>
      ) : (
        <div>
          <Typography variant="h4" gutterBottom>
            Welcome to Ganesh!
          </Typography>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/login"
          >
            Please Login
          </Button>
        </div>
      )}
    </Box>
  );
}

export default Home;
